/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 혜택 종류
 */
export type CreditPointCouponProfileBenefitType = 'UserCreditPoint' | 'CreditPointCoupon';

export const CreditPointCouponProfileBenefitType = {
    UserCreditPoint: 'UserCreditPoint' as CreditPointCouponProfileBenefitType,
    CreditPointCoupon: 'CreditPointCoupon' as CreditPointCouponProfileBenefitType
};

